import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { SpinnerService } from '@core';

@Component({
    selector: 'ups-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent {
  public active$: Observable<Boolean>;

  constructor(private readonly spinnerService: SpinnerService) {
    this.active$ = this.spinnerService.spinnerStatus$;
  }
}
